import React, {createRef, useContext, useEffect} from "react";
import InputField from "../../FormFields/InputField";
import PhoneInput from "react-phone-number-input";
import InputRefField from "../../FormFields/InputRefField";
import {useFormikContext} from "formik";
import CuitGenerator from "../../../Utils/CuitGenerator";
import SelectField from "../../FormFields/SelectField";
import DateField from "../../FormFields/DateField";
import ClienteDirectoContext from "../../../../context/ClienteDirectoContext";
import TarjetaCreditoFields from "../../FormFields/TarjetaCreditoFields";
import CbuFields from "../../FormFields/CbuFields";
import {Grid} from "@mantine/core";

export default function TitularForm({formField}) {
    const {
        cliente: {
            nombre, apellido, telefono, email, sexo, dni, cuit, fechaNacimiento, calle, numero, opcional
        },
        formaDePago,
    } = formField;

    const {values, setFieldValue} = useFormikContext();
    const extraTCFieldsNames = values.compania === "Sancor" ? ["vencimiento"] : [];
    const ref = createRef();
    const {companiesDict, genericOptionsFormasDePago} = useContext(ClienteDirectoContext)

    const formasDePago = values.compania ? companiesDict[values.compania].codigoFormasDePago : {};
    const marcasTarjeta = values.compania ? companiesDict[values.compania].idsTarjeta : [];
    const filteredOptions = genericOptionsFormasDePago.filter(option =>
        formasDePago.hasOwnProperty(option.value)
    );

    const opcionesSexo = [
        {value: '1', label: 'Femenino'},
        {value: '2', label: 'Masculino'}
    ];

    useEffect(() => {
        if (values.cliente.dni) {
            if ((values.cliente.dni).length === 8 && values.cliente.sexo !== '') {
                let generatedCuit = CuitGenerator(values.cliente.dni, values.cliente.sexo)
                setFieldValue('cliente.cuit', generatedCuit)
            }
        }
    }, [values.cliente.dni, values.cliente.sexo]);

    return (
        <React.Fragment>
            <Grid align="center">
                <Grid.Col xs={12} sm={6}>
                    <InputField
                        name={`cliente.${nombre.name}`}
                        label={nombre.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <InputField
                        name={`cliente.${apellido.name}`}
                        label={apellido.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <SelectField
                        name={`cliente.${sexo.name}`}
                        label={sexo.label}
                        data={opcionesSexo}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <InputField
                        name={`cliente.${dni.name}`}
                        label={dni.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <InputField
                        name={`cliente.${cuit.name}`}
                        label={cuit.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <DateField
                        name={`cliente.${fechaNacimiento.name}`}
                        label={fechaNacimiento.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <div className="field">
                        <PhoneInput
                            defaultCountry="AR"
                            ref={ref}
                            inputComponent={InputRefField}
                            name={`cliente.${telefono.name}`}
                            label={telefono.label}
                            withAsterisk
                            value={values.cliente.telefono}
                            onChange={(e) => {
                                setFieldValue(`cliente.${telefono.name}`, e)
                            }}
                        />
                    </div>
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <InputField
                        name={`cliente.${email.name}`}
                        label={email.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <InputField
                        name={`cliente.${calle.name}`}
                        label={calle.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <InputField
                        name={`cliente.${numero.name}`}
                        label={numero.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <InputField
                        name={`cliente.${opcional.name}`}
                        label={opcional.label}
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <SelectField
                        name={formaDePago.name}
                        label={formaDePago.label}
                        data={filteredOptions}
                        withAsterisk
                    />
                </Grid.Col>
                {values.formaDePago === 'TC' && (
                        <TarjetaCreditoFields formField={formField.infoDePago} extraFieldsNames={extraTCFieldsNames}
                                              marcas={marcasTarjeta}/>
                )}
                {values.formaDePago === 'CBU' && (
                        <CbuFields formField={formField.infoDePago} extraFieldsNames={[]}/>
                )}
            </Grid>
        </React.Fragment>
    );
}
